import Serializer from 'umg-ember-backend/serializers/application';

export default class AssetSerializer extends Serializer {
  attrs = {
    ownedByChannel: 'ownedByChannelId',
  };
}
